import { render, staticRenderFns } from "./SectionScheme.vue?vue&type=template&id=63b095b1&"
import script from "./SectionScheme.vue?vue&type=script&lang=js&"
export * from "./SectionScheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports